<template>
  <div id="mtn_app">
    <div class="row">
      <div class="col-12 loader-cont" v-if="!show || error">
        <Loader v-if="!show & !error"/>
        <Error v-if="error & !show"/>
      </div>
      <div class="col-lg-7 col-12 sec-height backgroundApp" style="padding-top: 0 "  >
<!--        :style="{ 'background': 'url( ' + require('../../assets/images/' + info.background) + ') no-repeat center right'}"-->
        <img class="w-100 h-100 back-size-100 mtnApp" :src="base + '/customerCare' + info.img" v-if="show && !error" :class="lang === 'ar' ? 'arabicImage'  : ''">
        <img class="w-100 h-100 back-size-100 mtnApp display" :src="base + '/customerCare' + info.smallImg" v-if="show && !error" :class="lang === 'ar' ? 'arabicImage'  : ''">
      </div>
      <div class="col-lg-5 col-12 flex-center text-left" id="myDiv" :class="lang === 'ar' ? 'arabicHeight'  : ''">
        <div class="w-100" v-if="show && !error" :class="this.$lang === 'ar' ? 'padding-2-ar' : 'padding-2-en'">
          <div class="main-title mb-2" style="padding: 0!important;" :class="lang === 'ar' ? 'arabicDir right-dir'  : ''">{{info.title}}</div>
          <div class="description" :class="lang === 'ar' ? 'arabicDir'  : ''">{{info.description}}</div>
          <div class="main-title font-18 mb-3" :class="lang === 'ar' ? 'arabicDir'  : ''">{{$t('mtnApp.downloadApp')}}</div>
          <div  :class="lang === 'ar' ? 'rightButtons'  : ''">
          <div :class="[$store.state.window < 380 && this.$lang === 'ar' ? 'right-dir' : '','buttons']">
            <v-btn :class="[$store.state.window < 380 ? '' : 'mr-4' ,'flex-center download-btn']" :href="info.store" target="_blank">
              <img class="icon" src="../../assets/icons/apple.svg">
              <div>
                <div class="download">{{$t('mtnApp.download')}}</div>
                <div class="site">iPhone</div>
              </div>
            </v-btn>
            <v-btn class="flex-center download-btn" :href="info.google" target="_blank">
              <img class="icon" src="../../assets/icons/google.svg">
              <div>
                <div class="download">{{$t('mtnApp.git')}}</div>
                <div class="site">Android</div>
              </div>
            </v-btn>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import CommercialAppRepository from '../../repositories/CommercialAppRepository'
import gc from '../../utils/gc'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
export default {
  name: 'MtnApp',
  components: { Loader, Error },
  data () {
    return {
      lang: this.$lang,
      commercialApp: new CommercialAppRepository(),
      show: false,
      error: false,
      display: this.show,
      info: {
        title: '',
        description: '',
        google: '',
        store: '',
        img: '',
        smallImg: '',
        background: 'MtnAppBack.png'
      },
      base: gc.baseUrl,
      height: '10px'
    }
  },
  mounted () {
    this.getData()
    setTimeout(() => {
      this.$lang === 'ar' ? $('.sec-height').css('transform', 'rotateY(180deg)') : $('.sec-height').css('transform', 'rotateY(0deg)')
      this.$lang === 'ar' ? $('#mtn_app .main-title').css('text-align', 'right') && $('#mtn_app .description').css('text-align', 'right') && $('#mtn_app .buttons').css('justify-content', 'flex-end') : $('#mtn_app div:first-child').addClass('flex-lg-row-reverse')
      this.$lang === 'ar' ? $('#mtn_app .main-title').css('font-family', 'Mtn-arabic-bold') : $('#mtn_app .main-title').css('font-family', 'Mtn-bold-italic')
      this.$lang === 'ar' ? $('#mtn_app .description').css('font-family', 'Mtn-arabic-regular') : $('#mtn_app .description').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('#mtn_app .mtnApp').css('transform', 'rotateY(180deg)') : $('#mtn_app .mtnApp').css('transform', 'rotateY(0deg)')
      this.$lang === 'ar' ? $('#mtn_app .mtnApp').css('box-shadow', '29px 0px 40px -27px rgba(0, 0, 0, 0.3)') : $('#mtn_app .mtnApp').css('box-shadow', '-29px 0px 40px -27px rgba(0, 0, 0, 0.3)')
    })
    // this.height = document.getElementById('myDiv').offsetHeight
    // $('.sec-height').css('height', this.height)
    // $('#mtn_app').resize(function () {
    //   this.height = document.getElementById('myDiv').offsetHeight
    //   $('.sec-height').css('height', this.height)
    // })
  },
  methods: {
    async getData () {
      try {
        const response = await this.commercialApp.get()
        if (response.status === 200) {
          this.info.google = response.data.link
          this.info.store = response.data.appleLink
          if (this.$lang === 'en') {
            this.info.description = response.data.description.slice(0, 468)
            if (response.data.description.length > 468) {
              this.info.description = response.data.description.slice(0, 468) + ' ...'
            }
          } else if (this.$lang === 'ar') {
            this.info.description = response.data.description.slice(0, 354)
            if (response.data.description.length > 354) {
              this.info.description = response.data.description.slice(0, 354) + ' ...'
            }
          }
          this.info.title = response.data.title
          this.info.img = response.data.largeImage
          this.info.smallImg = response.data.smallImage
          this.show = true
          this.error = false
        } else {
          this.error = true
          this.show = false
        }
      } catch (e) {
        this.error = true
        this.show = false
        console.log(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
.loader-cont {
  height: 38.88vw !important;
}
#mtn_app .description {
  font-size: 14px!important;
}
#mtn_app{
  position: relative;
}
.arabicDir{
  text-align: right !important;
}
.rightButtons{
  display: flex;
  justify-content: right!important;
}
.main-title {
  font-style: italic;
}
.v-btn {
  text-transform: initial!important;
}
.download {
  font-size: 10px!important;
}
.sec-height {
  //height: 750px;
  //min-height: 400px;
  //min-height: 400px;
}
.description {
  //margin-bottom: 2.5rem;
}
.icon {
  margin-right: 7px;
  width: 22px;
}
.site {
  margin-top: -3px;
  font-size: 15px!important;
  font-family: Mtn-bold;
}
.padding-2-en {
  padding: 1.8rem 0.5rem 1.8rem 2rem;
}
.padding-2-ar {
  padding: 1.8rem 2rem 1.8rem 0.5rem;
}
.display {
  display: none;
}
@media screen and (max-width: 1200px){
  .padding-2 {
    //padding: 1rem 2.5rem!important;
  }
}
@media screen and (min-width: 380px) {
  .buttons {
    display: flex;
  }
}
/*@media screen and (max-width: 1400px) {*/
/*  .sec-height {*/
/*    padding-bottom: 10px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 1390px) {*/
/*  .sec-height {*/
/*    padding-bottom: 0px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 1550px) {*/
/*  .sec-height {*/
/*    height: 604px !important*/
/*  }*/
/*}*/
/*@media screen and (max-width: 1369px) {*/
/*  .sec-height {*/
/*    height: 627px !important*/
/*  }*/
/*}*/
/*@media screen and (max-width: 1314px) {*/
/*  .sec-height {*/
/*    height: 650px !important*/
/*  }*/
/*}*/
/*@media screen and (max-width: 1224px) {*/
/*  .sec-height {*/
/*    height: 672px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 1130px) {*/
/*  .sec-height {*/
/*    height: 695px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 1102px) {*/
/*  .sec-height {*/
/*    height: 717px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 1047px) {*/
/*  .sec-height {*/
/*    height: 740px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 1008px) {*/
/*  .sec-height {*/
/*    height: 760px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 1270px) and (min-width: 992px) {*/
/*  .sec-height {*/
/*    height: 586px !important;*/
/*  }*/
/*}*/
@media screen and (max-width: 992px) and (min-width: 768px) {
  .sec-height {
    /*height: 550px !important;*/
    //min-height: 550px
  }
}
/*@media screen and (max-width: 768px) and (min-width: 650px) {*/
/*  .sec-height {*/
/*    height: 500px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 650px) and (min-width: 550px) {*/
/*  .sec-height {*/
/*    height: 430px !important;*/
/*  }*/
/*}*/
.mtnApp{
  width: 58vw !important;
  height: 38vw !important;
  //width: 100% !important;
  //height: auto !important;
  //margin: 0 5vw!important;
  //box-shadow: -29px 0px 40px -40px rgba(0, 0, 0, 0.3);
  }
@media screen and (max-width: 1145px) {
  #mtn_app .description {
    font-size: 13px!important;
  }
}
@media screen and (max-width: 550px) {

}
@media screen and (max-width: 991px) {
  .loader-cont {
    //ratio 1.04
    width: 100vw !important;
    height: 96vw !important;
  }
  .mtnApp {
    width: 100vw !important;
    height: 96vw !important;
    /*width: 100% !important;*/
    /*padding: 30px !important;*/
    //margin: 0!important;
    display: none;
  }
  .display{
    display: block;
  }
  .backgroundApp{
    //padding-bottom: 0;
    /*background-image: none !important;*/
  }
}
  .arabicImage{
    transform: rotateY(180deg);
    //box-shadow: 29px 0px 40px -40px rgba(0, 0, 0, 0.3);
  }
  .arabicHeight{
     //min-height: 605px
  }
</style>
<style>
#mtn_app .theme--light.v-btn.v-btn--has-bg, #mtn_app .theme--light.v-btn.v-btn--has-bg::before {
  background: transparent !important;
  box-shadow: none!important;
}
</style>
